import { useEffect } from "react";
import AppRoutes from "./AppRoutes";
import { addLocale,locale } from "primereact/api";
import moment from "moment";
import 'moment/locale/tr';

function App() {
  useEffect(() => {
    addLocale("tr", {
      firstDayOfWeek: 1,
      closeText: "kapat",
      prevText: "geri",
      nextText: "ileri",
      currentText: "bugün",
      monthNames: [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ],
      monthNamesShort: [
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara",
      ],
      dayNames: [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
      ],
      dayNamesShort: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
      dayNamesMin: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
      weekHeader: "Hf",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: "",
      timeOnlyTitle: "Zaman Seçiniz",
      timeText: "Zaman",
      hourText: "Saat",
      minuteText: "Dakika",
      secondText: "Saniye",
      ampm: false,
      month: "Ay",
      week: "Hafta",
      day: "Gün",
      emptyMessage: "Seçilecek bir öğe yok",
    });
    locale("tr");

    moment.locale("tr");
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 col-md-center">
          <AppRoutes />
        </div>
      </div>
    </div>
  );
}

export default App;
